<script>
  import { authComputed } from '@store/helpers'
  export default {
    props: {
      id: {
        type: String,
        default: '',
      }
    },
    computed: {
      ...authComputed
    },
  }
</script>

<template>
  <div v-if="currentUser && currentUser.showId" :class="$style.devInfo">
    Dev: <slot />
  </div>
</template>

